
import { defineComponent } from '@vue/composition-api';
import { mapGetters, mapActions } from 'vuex';
import { MyBet } from '../../../../../types/sport';
import BetItem from './BetItem.vue';
import BetListModal from './BetListModal.vue';

export default defineComponent({
  name: 'IllinoisMyBets',
  components: {
    BetItem,
    BetListModal
  },
  data() {
    const now = new Date();
    const oneMonthAgo = new Date(
      now.getFullYear(),
      now.getMonth() - 1,
      now.getDate()
    );

    return {
      loading: true,
      showListModal: false,
      showOnlyMyBets: true
    };
  },
  computed: {
    ...mapGetters({
      getAuthenticated: 'user/getAuthenticated',
      getMyBets: 'user/getMyBets',
      getUserType: 'user/getType',
      getCashier: 'user/getCashier'
    }),
    myBets(): MyBet[] {
      return this.getMyBets || [];
    },
    showOnlyMyBetsToggle(): boolean {
      return (
        (this.getUserType != null && this.getUserType === 4) ||
        (this.getCashier != null && this.getCashier === true)
      );
    }
  },
  watch: {
    showOnlyMyBets(newValue: boolean, oldValue: boolean) {
      if (newValue !== oldValue) {
        this.initialize();
      }
    }
  },
  async created() {
    await this.initialize();
  },
  methods: {
    ...mapActions({
      fetchMyBets: 'user/fetchMyBets',
      setDetailMyBet: 'user/setDetailMyBet',
      fetchEventResultAndTimeDetail: 'odds/fetchEventResultAndTimeDetail'
    }),
    t(key: string): string {
      return this.$t(key) as string;
    },
    async initialize(): Promise<void> {
      this.loading = true;
      this.$emit('loading-change', true);
      try {
        const payload: { all: boolean; showOnlyMyBets?: boolean } = {
          all: false
        };
        if (this.showOnlyMyBetsToggle) {
          payload.showOnlyMyBets = this.showOnlyMyBets;
        }
        await this.fetchMyBets(payload);
      } catch (error) {
        console.error('Error fetching my bets:', error);
      } finally {
        this.loading = false;
        this.$emit('loading-change', false);
        this.$emit('bets-loaded', this.myBets.length > 0);
      }
    },
    async openDetail(bet: MyBet): Promise<void> {
      try {
        // Preparare i dati della bet (live scores se necessario)
        if (bet.result === 'pending') {
          for (let i = 0; i < bet.odds.length; i++) {
            const data = await this.getLiveDate(bet.odds[i].event_source);
            if (data && data.livescore) {
              const time_actual = data.livescore.Scoreboard?.Time || 0;
              const result_actual = data.livescore.Scoreboard?.Results || [];
              bet.odds[i].show_time = true;
              bet.odds[i].time_actual = Number(time_actual) / 60;
              bet.odds[i].result_actual_home = this.getResult(
                result_actual,
                'home'
              );
              bet.odds[i].result_actual_away = this.getResult(
                result_actual,
                'away'
              );
            } else {
              bet.odds[i].show_time = false;
              bet.odds[i].time_actual = '';
              bet.odds[i].result_actual_home = '';
              bet.odds[i].result_actual_away = '';
            }
          }
        }

        this.setDetailMyBet(bet);
        // Emettere evento per aprire il modal in Main.vue
        this.$root.$emit('openBetDetailModal', bet);
      } catch (error) {
        console.error('Error opening bet detail:', error);
      }
    },
    openAllBets(): void {
      this.showListModal = true;
    },
    async handleSelectBetFromList(bet: MyBet): Promise<void> {
      this.showListModal = false;
      await this.openDetail(bet);
    },
    async getLiveDate(eventSource: number): Promise<{
      livescore?: {
        Scoreboard?: {
          Time?: number;
          Results?: Array<{ Position: string; Value: string }>;
        };
      };
    } | null> {
      try {
        const data = await this.fetchEventResultAndTimeDetail({
          source: eventSource
        });
        return data;
      } catch {
        return null;
      }
    },
    getResult(
      result: Array<{ Position: string; Value: string }>,
      team: string
    ): number | string {
      if (!result || !Array.isArray(result)) return 0;
      const position = team === 'home' ? '1' : '2';
      const point = result.find(r => r.Position === position);
      return point ? +point.Value : 0;
    }
  }
});
